export const Z_INDEXES = {
  CUSTOMIZE_MENU_HEADER: 9,
  ERROR_WRAPPER: 100,
  PLANNER_MESSAGE_WRAPPER: 100,
  DRAW_FLIP_PANEL_BUTTON: 2000,
  COUNTDOWN_BANNER_WRAPPER: 9999,
  LOADING_SCREEN_CONTAINER: 99999
};
